<template>
  <div class="ale-collect">
    <div class="ale-collect-box" :class="item.ty" v-for="item in importantData" :key="item.id">
      <h3 :class="item.data.spread > 0 ? 'ale-red' : (item.data.spread < 0 ? 'ale-green' : '')">{{ item.data.value || '--' }}<span>{{ item.data.value || '--' }}</span><i>{{ item.data.spread }}</i></h3>
      <p>{{ item.name }}</p>
      <em>{{ item.data.date || '--' }}</em>
    </div>
  </div>
</template>

<script>
export default {
  name: 'screen1',
  props: {
    getData: {
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      importantData: [
        { id: '2182', name: 'PTA', data: {}, ty: 'collect1' },
        { id: '48', name: 'MEG', data: {}, ty: 'collect2' },
        { id: '113', name: 'CPL', data: {}, ty: 'collect4' },
        { id: '256', name: 'WTI', data: {}, ty: 'collect5' },
        { id: '205', name: '棉花', data: {}, ty: 'collect3' }
      ]
    }
  },
  watch: {
    getData (val) {
      this.getIndicator(val)
    }
  },
  mounted () {
    this.getIndicator(this.getData)
  },
  methods: {
    getIndicator (val) {
      if (val.length > 0) {
        this.importantData.map(vals => {
          vals.data = val.filter(value => value.indicatorId === vals.id)[0]
        })
        console.log('数据来了！', this.importantData)
      }
    }
  }
}
</script>

<style scoped>

.ale-collect-box{
  width: 710px;
  height: 567px;
  background: url("../../../assets/ale/sz-bg.png") no-repeat center/100%;
  text-align: center;
  color: #fff;
  display: inline-block;
}

.ale-collect-box h3{
  margin-top: 36px;
  margin-bottom: 0;
  font-family: Bahnschrift;
  display: inline-block;
  font-size: 212px;
  height: 210px;
  position: relative;
  letter-spacing: 2px;
  font-weight: normal;
  color: #fff;
  text-shadow: 0 20px 26px #000;
}
.ale-collect-box h3 span{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,#ffffff 74%,#0541A5,#000);
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: none;
}
.ale-collect-box h3 i{
  position: absolute;
  bottom: 0;
  left: 101%;
  font-size: 65px;
  font-style: normal;
}

.ale-red span{
  background: linear-gradient(to bottom,#ffffff 60%,#f00,#000) !important;
  -webkit-background-clip: text !important;
}
.ale-green span{
  background: linear-gradient(to bottom,#ffffff 60%,#00FF00,#000) !important;
  -webkit-background-clip: text !important;
}

.ale-collect-box p{
  font-size: 80px;
  font-weight: bold;
  text-shadow: 0 12px 16px #000;
}

.ale-collect-box em{
  font-style: normal;
  font-size: 50px;
  text-shadow: 0 12px 16px #000;
  color: #fefefe;
}

.collect1{
  position: absolute;
  left: 2.5%;
  top: 60px;
  z-index: 1;
}
.collect2{
  position: absolute;
  left: 2.5%;
  bottom: 1%;
  z-index: 6;
}
.collect3{
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -283px;
  margin-left: -335px;
  z-index: 3;
}
.collect4{
  position: absolute;
  right: 2.5%;
  top: 60px;
  z-index: 1;
}
.collect5{
  position: absolute;
  right: 2.5%;
  bottom: 1%;
  z-index: 6;
}
</style>



// WEBPACK FOOTER //
// src/views/ale/modules/screen1.vue